import { HttpInterceptorFn, HttpRequest, HttpHandlerFn, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { EMPTY, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AlertService } from 'src/app/shared/services/alert/alert.service';
import { DEFAULT_ERROR_MESSAGE, ERROR_LIST } from 'src/app/core/constants/error-handling-list/error-list.enum';
import { ERROR_IGNORE_LIST } from 'src/app/core/constants/error-handling-list/error-ignore-list';
import { ErrorCode } from 'src/app/core/constants/error-handling-list/error-code';
import { ScheduledRoundsQueryCacheService } from 'src/app/core/services/scheduled-rounds-query-cache.service';
import { GlobalSpinnerService } from 'src/app/shared/services/global-spinner.service';
import { SKIP_ERROR_HANDLING } from 'src/app/core/interceptors/skip-error-handling.context';

export const errorInterceptor: HttpInterceptorFn = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const alertService = inject(AlertService);
  const scheduledRoundsQueryCache = inject(ScheduledRoundsQueryCacheService);
  const router = inject(Router);
  const globalSpinnerService = inject(GlobalSpinnerService);

  const displayCodeError = (error: HttpErrorResponse) => {
    const code = error.error.code as string;
    if (code === ErrorCode.ScheduledRoundAlreadyCompleted) {
      scheduledRoundsQueryCache.invalidateAll();
    }
    const knownMessage = ERROR_LIST[code as keyof typeof ERROR_LIST];
    if (!knownMessage) {
      console.error(`Unmapped API error code "${code}" with status ${error.status} for ${error.url}`);
    }
    alertService.addErrorAlert(knownMessage ?? DEFAULT_ERROR_MESSAGE);
    if (code === ErrorCode.ReportArchivedEmployeeAccessDenied && router.url.includes('employee-statistics')) {
      globalSpinnerService.setIsLoading(true);
      router.navigate(['/dashboard']).finally(() => globalSpinnerService.setIsLoading(false));
    }
    return EMPTY;
  };

  return next(request).pipe(
    catchError((error: HttpErrorResponse) => {
      if (request.context.get(SKIP_ERROR_HANDLING)) {
        return throwError(() => error);
      }
      if (
        error.error?.code &&
        error.status !== 401 &&
        error.status !== 404 &&
        !error.url?.includes('google') &&
        !error.url?.includes('microsoft') &&
        !ERROR_IGNORE_LIST.includes(error.error.code)
      ) {
        return displayCodeError(error);
      } else {
        return throwError(() => error);
      }
    })
  );
};
